import { useQuery, useMutation } from "react-query"
import customAxios from "../utils/customAxios"
import { toast } from "react-toastify"
import { AxiosError } from "axios"
import { useNavigate } from "react-router-dom"
import { useCookies } from "react-cookie"

const axios = customAxios()

interface AuthRegisterType {
  username: string
  first_name: string
  last_name: string
  password: string
  password2: string
  email: string
}

interface UserInfoPayloadType {
  username: string
  position: string
  mobile_carrier: string
  phone_number: string
  advertisement: string
  school: string
  grade: string
}

interface Props {
  userRegisterPayload: AuthRegisterType
  userInfoRegisterPayload: UserInfoPayloadType
}

export const useUserRegister = () => {
  const { mutate: login } = useAuthLogin()

  const fecthUserRegister = async (props: Props) => {
    await axios.post("/users/register/", props.userRegisterPayload)
    await axios.post("/users/user_info/", props.userInfoRegisterPayload)
    return login({
      username: props.userRegisterPayload.username,
      password: props.userRegisterPayload.password,
    })
  }

  return useMutation(fecthUserRegister, {
    onSuccess: () => {
      toast.success("회원가입이 완료되었습니다.", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      })
    },
    onError: (error: AxiosError) => {
      console.log(error)
      toast.error("서버 에러입니다.", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      })
    },
  })
}

interface LoginPayloadType {
  username: string
  password: string
}

const fetchAuthLoginApi = (loginPayload: LoginPayloadType) => {
  return axios.post(`/users/login/`, loginPayload)
}

export const useAuthLogin = () => {
  const navigate = useNavigate()
  const [, setCookie, removeCookie] = useCookies([
    "accessToken",
    "username",
    "email",
  ])
  return useMutation(fetchAuthLoginApi, {
    onSuccess: (data) => {
      console.log(data)
      setCookie("username", data.data.first_name, {
        path: "/",
        maxAge: 60 * 60, // 유효 기한 일단 한 시간
        // secure: true,
        // httpOnly: true,
      })
      setCookie("email", data.data.username, {
        path: "/",
        maxAge: 60 * 60, // 유효 기한 일단 한 시간
        // secure: true,
        // httpOnly: true,
      })
      setCookie("accessToken", data.data.token, {
        path: "/",
        maxAge: 60 * 60, // 유효 기한 일단 한 시간
        // secure: true,
        // httpOnly: true,
      })
      toast.success("로그인 성공")
      navigate("/")
    },
    onError: (error: AxiosError) => {
      console.log(error)
      removeCookie("accessToken")
      toast.error("로그인 정보가 일치하지 않습니다.")
    },
  })
}

const fetchAuthDuplicateApi = ({ queryKey }: any) => {
  const prop = queryKey[1] // parse value
  return axios.get(`/users/register/duplicateid?email=${prop.email}`)
}

export const useAuthDuplicate = (prop?: any) => {
  return useQuery(["fetchAuthDuplicateApi", prop], fetchAuthDuplicateApi, {
    staleTime: 10000,
    select: select,
    onError,
    refetchOnWindowFocus: false,
    enabled: false,
  })
}

// api 응답 데이터 가공하는 부분
const select = (response: any) => {
  return response.data
}

const onError = (err: any) => {
  return err
}
